import { render, staticRenderFns } from "./ktradelog.vue?vue&type=template&id=1ce7d838"
import script from "./ktradelog.vue?vue&type=script&lang=js"
export * from "./ktradelog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports